import { render, staticRenderFns } from "./NavbarForum.vue?vue&type=template&id=ff45e41c"
import script from "./NavbarForum.vue?vue&type=script&lang=js"
export * from "./NavbarForum.vue?vue&type=script&lang=js"
import style0 from "./NavbarForum.vue?vue&type=style&index=0&id=ff45e41c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports